// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  // search de izlenir: /urunler?marka=SGS -> ?marka=Dekor aynı sayfa ama yeni içerik
  // Adreste #bolum varsa (ör. reklamdaki /yeni/soguk-asfalt#hesapla) o bölüme kaydırılır;
  // sayfa içeriği veriyle geç oluşabildiği için öğe birkaç kez aranır.
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    let deneme = 0;
    const zamanlayici = setInterval(() => {
      const hedef = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (hedef || ++deneme > 20) {
        clearInterval(zamanlayici);
        // Ani atlama: reklamdan/bağlantıdan gelen ziyaretçi uzun bir kaydırma animasyonu beklemesin
        hedef?.scrollIntoView({ behavior: "auto", block: "start" });
      }
    }, 100);
    return () => clearInterval(zamanlayici);
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
